import styles from "../SMSToggle.module.css";
import { bool, string } from "prop-types";

const Toggle = ({ className, checkedClassName, boxClassName, active }) => {
  return (
    <div className={`${styles.toggleSwitch} ${className}`}>
      <div
        className={`${styles.toggleTrack} ${boxClassName} ${
          active ? styles.activeTrack : ""
        }`}
      />
      <div
        className={`${styles.toggleThumb} ${checkedClassName} ${
          active ? styles.activeThumb : ""
        }`}
      />
    </div>
  );
};

Toggle.defaultProps = {
  className: null,
  checkedClassName: null,
  boxClassName: null,
};

Toggle.propTypes = {
  className: string,
  checkedClassName: string,
  boxClassName: string,
  active: bool,
};

export default Toggle;
